import React, { useState, useEffect } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { NavLink } from "react-router-dom";
import { IoMenu, IoClose } from "react-icons/io5";
import scrollToTop from "../components/scrolltoTop";

const Header = () => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  useEffect(() => {
    const handleScroll = () => {
      // const heroHeight = document.getElementById("hero")?.offsetHeight || 0;
      setScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`header ${scrolled ? "scrolled" : ""}`}>
      <div className="logo">
        <Link to="/" onClick={scrollToTop}>
          <img
            className="header-logo"
            src="https://d1g9iww9o5ioh1.cloudfront.net/logos/orangeLogo.webp"
            alt="TAC Logo"
          ></img>
        </Link>
      </div>
      <div className="desktop-menu">
        <ul className="menuop">
          <li>
            <NavLink
              className={({ isActive }) =>
                isActive ? "nav-active" : "menu-item"
              }
              to="/about"
              onClick={scrollToTop}
            >
              About us
            </NavLink>
          </li>
          <li>
            <NavLink
              className={({ isActive }) =>
                isActive ? "nav-active" : "menu-item"
              }
              to="/events"
              onClick={scrollToTop}
            >
              Events
            </NavLink>
          </li>
          <li>
            <NavLink
              className={({ isActive }) =>
                isActive ? "nav-active" : "menu-item"
              }
              to="/blog"
              onClick={scrollToTop}
            >
              Blog
            </NavLink>
          </li>
          <li>
            <NavLink
              className={({ isActive }) =>
                isActive ? "nav-active" : "menu-item"
              }
              to="/artists"
              onClick={scrollToTop}
            >
              Our Artists
            </NavLink>
          </li>
          <li>
            <NavLink
              className={({ isActive }) =>
                isActive ? "nav-active" : "menu-item"
              }
              to="/contact"
              onClick={scrollToTop}
            >
              Contact us
            </NavLink>
          </li>
        </ul>
      </div>
      <div className={`alt-menu ${scrolled ? "scrolled" : ""}`}>
        <span className="menu-icons" onClick={toggleDropdown}>
          {isDropdownVisible ? (
            <IoClose className="close-icon" />
          ) : (
            <IoMenu className="menu-icon" />
          )}
        </span>
      </div>
      <div
        className={`alt-menu-dropdown ${isDropdownVisible ? "show" : "hiding"}`}
      >
        <div className="menuop">
          <div>
            <Link
              className="menu-it"
              to="/about"
              onClick={() => {
                toggleDropdown();
                scrollToTop();
              }}
            >
              About us
            </Link>
          </div>
          <div>
            <Link
              className="menu-it"
              to="/events"
              onClick={() => {
                toggleDropdown();
                scrollToTop();
              }}
            >
              Events
            </Link>
          </div>
          <div>
            <Link
              className="menu-it"
              to="/blog"
              onClick={() => {
                toggleDropdown();
                scrollToTop();
              }}
            >
              Blog
            </Link>
          </div>
          <div>
            <Link
              className="menu-it"
              to="/artists"
              onClick={() => {
                toggleDropdown();
                scrollToTop();
              }}
            >
              Our Artists
            </Link>
          </div>
          <div>
            <Link
              className="menu-it"
              to="/gallery"
              onClick={() => {
                toggleDropdown();
                scrollToTop();
              }}
            >
              Gallery
            </Link>
          </div>
          <div>
            <Link
              className="menu-it"
              to="/contact"
              onClick={() => {
                toggleDropdown();
                scrollToTop();
              }}
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
